import React from "react";

function Systemlog({ colorCode = "" }) {
  return (
    <svg
      className="MuiSvgIcon-root"
      viewBox="0 0 24 24"
      style={{ fill: "transparent" }}
    >
      <path
        d="M17 9L13.9558 13.5662C13.5299 14.2051 12.5728 14.1455 12.2294 13.4587L11.7706 12.5413C11.4272 11.8545 10.4701 11.7949 10.0442 12.4338L7 17"
        stroke={"#51CBFF"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        stroke={colorCode}
        strokeWidth="2"
      ></rect>
    </svg>
  );
}

export default Systemlog;
